import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { snakeCase } from "lodash-es";

import { DeleteModal } from "shared/components";
import { dataMetaSelector } from "Bands/state";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { IAPIState, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";

interface Props {
  type: string;
  action: string;
  handleClose: () => void;
  handleDelete: () => void;
  successMessage: string;
}

export const DeleteUserEntityModal: React.FC<Props> = ({
  type,
  action,
  handleClose,
  handleDelete,
  successMessage,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(action));
  useClearActionMetaOnUnMount(action);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: successMessage,
        })
      );
    }
  }, [apiMeta?.status, dispatch, handleClose, successMessage]);

  return (
    <DeleteModal
      name=""
      type={type}
      dataTestId={`delete_${snakeCase(type)}_modal`}
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
